export function responsiveCellSize(
  targetCells: number,
  maxWidth: number,
  defaultSize: number,
  minSize: number = 16,
): number {
  if (targetCells <= 0) return defaultSize
  const calculatedSize = Math.floor(maxWidth / targetCells)
  return Math.max(minSize, Math.min(calculatedSize, defaultSize))
}
